import { render, staticRenderFns } from "./ProBanner.vue?vue&type=template&id=26878b50&scoped=true&lang=pug"
import script from "./ProBanner.vue?vue&type=script&lang=js"
export * from "./ProBanner.vue?vue&type=script&lang=js"
import style0 from "./ProBanner.vue?vue&type=style&index=0&id=26878b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26878b50",
  null
  
)

export default component.exports